import clsx from 'clsx'
import isEqual from 'lodash/isEqual'
import React, { FC, useMemo } from 'react'

export const PaymentIcon: FC<{
  className?: string
  name: string
  onImageError?: () => void
  url: string
}> = ({ className, name, onImageError, url }) => (
  <img
    alt={name}
    className={clsx(className, name)}
    onError={({ currentTarget }) => {
      if (onImageError) {
        onImageError()
      }
      if (currentTarget) {
      // eslint-disable-next-line no-param-reassign
        currentTarget.style.display = 'none'
      }
    }}
    src={url}
    style={{
      maxHeight: 'inherit',
      objectFit: 'inherit',
    }}
  />
)

/**
 * @deprecated CardTypeIcon should not be used, use PaymentIcon instead
 */
export const CardTypeIcon: FC<{ cardType: string, className?: string, onImageError?: () => void }> = ({
  cardType,
  className,
  onImageError,
}) => {
  const iconUrl = useMemo(() => {
    const check = (...types: string[]) => !!types.find(t => isEqual(t.toLowerCase(), cardType.toLowerCase()))
    if (check('american-express')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt01b9a6f6c504688b/American_Express.svg'
    }
    if (check('applepay')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt8cc19562c6881a50/Apple_Pay.svg'
    }
    if (check('discover')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltfdbc5239a87d2726/discover.svg'
    }
    if (check('maestro')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt4cacedecafe58ffc/Maestro.svg'
    }
    if (check('mastercard')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt1d6973c8ed051199/Mastercard.svg'
    }
    if (check('visa-blue')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt1855650ba4ffda0b/visa-blue.svg'
    }
    if (check('visa-electron')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltf77efe5f07567fba/visa-electron.svg'
    }
    if (check('visa')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltdd732e4efe379cf0/Visa.svg'
    }
    if (check('visadankort')) {
      return 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt9cd6e4842e229953/visadankort.svg'
    }
    return ''
  }, [cardType])

  if (!iconUrl) {
    return null
  }

  return (
    <img
      alt={cardType}
      className={className}
      onError={({ currentTarget }) => {
        if (onImageError) {
          onImageError()
        }
        if (currentTarget) {
          // eslint-disable-next-line no-param-reassign
          currentTarget.style.display = 'none'
        }
      }}
      src={iconUrl}
      style={{
        maxHeight: 'inherit',
        objectFit: 'inherit',
      }}
    />
  )
}
